import { Injectable } from '@angular/core';
import { CryptoService } from '../../commonService/crypto.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { BehaviorSubject } from 'rxjs';
import { CookiesService } from '../../cookies.service';
import { PreviousPageCaptureService } from '../previous-page-capture.service';
import { Router } from '@angular/router';
import { PreviousPageCaptureBksService } from '../previous-page-capture-bks.service';

@Injectable({
  providedIn: 'root',
})
export class TravelerManagement {
  approvalListing = new BehaviorSubject<any>(null);
  $approvalList = this.approvalListing.asObservable();

  sendData(data: any) {
    this.approvalListing.next(data);
  }
  routeUrl = {
    currentRoute: '',
    nextRoute: '',
  };
  

  currectPageByUrl1(url: any) {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const segments = url.replace(/\/+$/, '').split('/');
    let lastSegment = segments.pop() || '';
    if (uuidRegex.test(lastSegment)) {
      lastSegment = segments.pop() || '';
    }
    if (/^\d+$/.test(lastSegment)) {
      lastSegment = segments.pop() || '';
    }
    if (lastSegment.includes('type=1') || lastSegment.includes('type=2')) {
      lastSegment = lastSegment.split('?')[0];
    }
    return lastSegment;
  }

  currectPageByUrl(url: any) {
    url = url.split('?')[0];
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const segments = url.replace(/\/+$/, '').split('/');
    let lastSegment = segments.pop() || '';
    if (uuidRegex.test(lastSegment)) {
      lastSegment = segments.pop() || '';
    }
    if (/^\d+$/.test(lastSegment)) {
      lastSegment = segments.pop() || '';
    }
    // ensure slug format
    return lastSegment.toLowerCase();
}

  constructor(
    private readonly navService:PreviousPageCaptureService,
    private readonly navServiceBks:PreviousPageCaptureBksService,
    private _Router: Router,
    private readonly crypto: CryptoService,
    private readonly _CommonService: CommonService,
    private readonly cookiesService: CookiesService,
  ) {}

  getUserRole(): string {
    const travelArranger = this.crypto.getValueFromKey(
      'ISCORPTRAVELARRANGER'
    ) as string;
    switch (travelArranger) {
      case '0':
        return 'Admin';
      case '1':
        return 'TravelArranger';
      case '2':
        return 'Employee';
      default:
        return '';
    }
  }
  // currectPageByUrl(url: any) {
  //   const uuidRegex =
  //     /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  //   const segments = url.replace(/\/+$/, '').split('/');
  //   let lastSegment = segments.pop() || '';
  //   if (uuidRegex.test(lastSegment)) {
  //     lastSegment = segments.pop() || '';
  //   }
  //   if (/^\d+$/.test(lastSegment)) {
  //     lastSegment = segments.pop() || '';
  //   }
  //   if (lastSegment.includes('type=1') || lastSegment.includes('type=2')) {
  //     lastSegment = lastSegment.split('?')[0];
  //   }
  //   return lastSegment;
  // }

  currentPage(): any {
    const url = this.currectPageByUrl(this.navService.getCurrentUrl);
    // Remove query params if they exist
    return url;
  }

  previousPage(): any {
    const url = this.currectPageByUrl(this.navService.getPreviousUrl);
    // Get last route segment
    return url;
  }

  previousPage2ndStep(): any {
    const url = this.currectPageByUrl(this.navServiceBks.getTwoStepBackUrl);
    // Get last route segment
    return url;
  }


  toTitleCase(text: string): string {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  // setGTM(analytics: any, scriptName: string, data: any) {
  //   if (this.hasAcceptedCookies()) {
  //     logEvent(analytics, scriptName, data);
  //   }
  // }
     setGTM(analytics: any, scriptName: string, data: any) {
    if (this.hasAcceptedCookies()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    }
  }
  hasAcceptedCookies(): boolean {
    let cookie = localStorage.getItem('cookieAccepted') === 'true';
    return cookie;
  }

  page_landing(eventCategory: string, resultCount: any, subAction: string) {
    try {

      const eventData = {
        'event': 'page_landing',
        'previous_screen_name':  this.previousPage(), // dynamically capture the previous page name/title, if no previous page, then NA
        // 'event_action': this.previousPage() || 'NA', // dynamically capture the previous tab user is on/title, if no previous page, then NA
        'screen_name':  this.currentPage() || 'NA', // dynamically capture the current page name/title
        'no_of_results': resultCount && resultCount > 0 ? resultCount : 'NA', // pass number of results, NA if not applicable
        'member': this.getUserRole(),   // dynamically capture ex: employee
        'action': this._CommonService.actionName,// dynamically capture the feature name
        'subaction': subAction// dynamically  capture the POD name
      }
      this.setGTM(this.cookiesService.analytics, 'page_landing', eventData);

    } catch (error) {
    }
  }

  traveler_add(CTALink: string, result: number,LinkName:string) {
    try {
      const eventData = {
        event: 'traveler_add',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        no_of_results: result || 'NA', // pass number of results, NA if not applicable
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'approval_add', eventData);
    } catch (error) {}
  }
  traveler_add_success(CTAaction:String) {
    try {
      const eventData = {
        event: 'traveler_add_success',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `${CTAaction} Click`,// Dynamically capture the CTA
        link_name: 'Success', // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_add_success', eventData);
    } catch (error) {}
  }
  bulkUploadAction(actionName: string, CTAClick: string) {
    try {
      const eventData = {
        event: 'upload_bulk_click',
        screen_name: 'Upload Bulk PopUp', // static
        event_action: `${CTAClick} Click`, // Dynamically capture the CTA eg: Checkbox_Check, Checkbox_Uncheck
        link_name: actionName, // dynamically capture CTA if applicable
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'upload_bulk_click',
        eventData
      );
    } catch (error) {}
  }

  uploadError(errorMsg: string) {
    try {
      const eventData = {
        event: 'file_upload_error',
        screen_name: 'Upload Bulk PopUp', // static
        event_action: `File upload error`, // Dynamically capture the CTA eg: Checkbox_Check, Checkbox_Uncheck
        link_name: errorMsg, // dynamically capture CTA if applicable
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'file_upload_error',
        eventData
      );
    } catch (error) {}
  }

  someUserUploadError(errorMsg: string) {
    try {
      const eventData = {
        event: 'profile_upload_error',
        screen_name: 'Profile Upload Error PopUp', // static
        event_action: `Profile upload error`, // Dynamically capture the CTA eg: Checkbox_Check, Checkbox_Uncheck
        link_name: errorMsg, // dynamically capture CTA if applicable
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'profile_upload_error',
        eventData
      );
    } catch (error) {}
  }

  fileError() {
    try {
      const eventData = {
        event: 'file_mismatch_error',
        screen_name: 'File Error PopUp', // static
        event_action: `File upload error`, // Dynamically capture the CTA eg: Checkbox_Check, Checkbox_Uncheck
        link_name: 'Uploaded file fields do not match the sample CSV', // dynamically capture CTA if applicable
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'file_mismatch_error',
        eventData
      );
    } catch (error) {}
  }
  add_traveler_cancel_click() {
    try {
      const eventData = {
        event: 'add_traveler_click',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `Cancel Click`, // Dynamically capture the CTA
        link_name: 'Cancel', // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name:  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'add_traveler_click',
        eventData
      );
    } catch (error) {}
  }

  add_dependents_details_cancel_click(CTALink:string) {
    try {
      const eventData = {
        event: 'add_dependent_click',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'add_dependent_click',
        eventData
      );
    } catch (error) {}
  }

  add_traveler_save_click(formData: any,userType:any) {
    try {
      const eventData = {
        event: 'add_traveler_save',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `Send invite click`, // Dynamically capture the CTA
        link_name: `Nationality :${formData?.nationality} | Place of residence : ${formData?.placeOfResidence} | User type: ${userType}`, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'add_traveler_save',
        eventData
      );
    } catch (error) {}
  }

  traveler_view_click(noOfResult: number) {
    try {
      const eventData = {
        event: 'traveler_view',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `View Click`, // Dynamically capture the CTA
        link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        no_of_results: noOfResult || 'NA',
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_view', eventData);
    } catch (error) {}
  }

  reporting_manager_manager_settings_click(noOfResult: number,CTALink:string) {
    try {
      const eventData = {
        event: 'manager_settings_click',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        no_of_results: noOfResult || 'NA',
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'manager_settings_click', eventData);
    } catch (error) {}
  }

  traveler_click(noOfResult: number,CTALink:string) {
    try {
      const eventData = {
        event: 'traveler_management_click',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
         link_name: CTALink,
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        no_of_results: noOfResult || 'NA',
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_management_click', eventData);
    } catch (error) {}
  }


  traveler_management_click(CTALink:string,noOfResult: number) {
    try {
      const eventData = {
        event: 'traveler_management_click',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
         link_name: CTALink,
        //  no_of_results: noOfResult || 'NA',
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_management_click', eventData);
    } catch (error) {}
  }

  traveler_management_clickSortFlt(CTALink:string,linkName: String) {
    try {
      const eventData = {
        event: 'traveler_management_click',
        screen_name: this.currentPage(), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
         link_name: `${linkName}_Sort`,
        //  no_of_results: noOfResult || 'NA',
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_management_click', eventData);
    } catch (error) {}
  }

  

  deactivate_success(CTALink:string, LinkName:string) {
    try {
      const eventData = {
        event: 'deactivate_success',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
         link_name: LinkName,
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'deactivate_success', eventData);
    } catch (error) {}
  }

  deactivate_click(CTALink:string){
    try {
      const eventData = {
        event: 'deactivate_click',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
         link_name: 'Remove', //static
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'deactivate_click', eventData);
    } catch (error) {}
  }
  

  // traveler_menu_click() {
  //   try {
  //     const eventData = {
  //       event: 'traveler_menu_click',
  //       screen_name: this.toTitleCase((this.currectPageByUrl(
  //         this.navService.getCurrentUrl
  //       )).replaceAll('-',' ')), // Dynamically capture the page name
  //       event_action: `Menu Click`, // Dynamically capture the CTA
  //       link_name: this.toTitleCase((this.currectPageByUrl(
  //         this.navService.getCurrentUrl
  //       )).replaceAll('-',' ')), // dynamically capture clicked CTA eg: Add_manual
  //       previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
  //       member: this.getUserRole(), // dynamically capture ex: employee
  //       action: this._CommonService.actionName, // dynamically capture the feature name
  //       subaction: 'Traveler Management Workflow', // dynamically capture the POD name
  //     };
  //     this.setGTM(this.cookiesService.analytics, 'traveler_menu_click', eventData);
  //   } catch (error) {}
  // }

  traveler_menu_click() {
    try {
      const eventData = {
        event: 'traveler_menu_click',
        screen_name: this.previousPage().replaceAll('-',' '), // Dynamically capture the page name
        event_action: `Menu Click`, // Dynamically capture the CTA
        link_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage2ndStep() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_menu_click', eventData);
    } catch (error) {}
  }


  traveler_detail_click(CTALink:string) {
    try {
      const eventData = {
        event: 'traveler_details_click',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_details_click', eventData);
    } catch (error) {}
  }

  traveler_detail_clickBackStep(CTALink:string) {
    try {
      const eventData = {
        event: 'traveler_details_click',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage2ndStep() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_details_click', eventData);
    } catch (error) {}
  }

  traveler_details(CTALink:string) {
    try {
      const eventData = {
        event: 'traveler_details',
        screen_name:'Document Edit PopUp', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_details', eventData);
    } catch (error) {}
  }

  document_remove(CTALink:string){
    try {
      const eventData = {
        event: 'document_remove',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name:this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'document_remove', eventData);
    } catch (error) {}
  }

  document_remove_success(CTALink:string){
    try {
      const eventData = {
        event: 'document_remove_success',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'document_remove_success', eventData);
    } catch (error) {}
  }

  traveler_dependents_detail_click(CTALink:string, noOfResult:number,LinkName:String) {
    try {
      const eventData = {
        event: 'traveler_details_click',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        // link_name: `View`, // dynamically capture clicked CTA eg: Add_manual
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        no_of_results: noOfResult || 'NA',
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_details_click', eventData);
    } catch (error) {}
  }



  document_click(eventName:string,CTALink:string) {
    try {
      const eventData = {
        event: eventName,
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, eventName, eventData);
    } catch (error) {}
  }
  saved_card_click(noOfResult: number,CTALink:string) {
    try {
      const eventData = {
        event: 'saved_card_click',
        screen_name: 'Saved Cards', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        no_of_results: noOfResult || 'NA',
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'saved_card_click', eventData);
    } catch (error) {}
  }

  saved_card_clickBackStep(noOfResult: number,CTALink:string) {
    try {
      const eventData = {
        event: 'saved_card_click',
        screen_name: 'Saved Cards', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage2ndStep() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        no_of_results: noOfResult || 'NA',
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'saved_card_click', eventData);
    } catch (error) {}
  }

  save_card_remove_click(CTALink:string, LinkName:string) {
    try {
      const eventData = {
        event: 'card_remove',
        screen_name: 'Card Remove PopUp', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'card_remove', eventData);
    } catch (error) {}
  }

  card_remove_success_click(CTALink:string,LinkName:string) {
    try {
      const eventData = {
        event: 'card_remove_success',
        screen_name: 'Card Remove popUp', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'card_remove_success', eventData);
    } catch (error) {}
  }

  dependent_approve_status(CTALink:string) {
    try {
      const eventData = {
        event: 'dependent_approve_status',
        screen_name: 'Dependent Information Form', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'dependent_approve_status', eventData);
    } catch (error) {}
  }

  dependent_approval_click(noOfResult:number,CTALink:string) {
    try {
      const eventData = {
        event: 'dependent_approval_click',
        screen_name: 'Dependent Information Form', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        no_of_results: noOfResult || 'NA',
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'dependent_approval_click', eventData);
    } catch (error) {}
  }

  family_management_click(noOfResult:number,CTALink:string) {
    try {
      const eventData = {
        event: 'family_management_click',
        screen_name: 'Family member management', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        no_of_results: noOfResult || 'NA',
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'family_management_click', eventData);
    } catch (error) {}
  }

  linkAccountPopUp(CTALink:string,LinkName:string){
    try {
      const eventData = {
        event: 'link_account_click',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'traveler_details_click', eventData);
    } catch (error) {}
  }

  
  authentication_popup(CTALink:string,authMethod:string){
    try {
      const eventData = {
        event: 'authentication_popup',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        authentication_method:authMethod,
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'authentication_popup', eventData);
    } catch (error) {}
  }

  authentication_popupMatch(CTALink:string,Linkname:string, authMethod:string){
    try {
      const eventData = {
        event: 'authentication_popup',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: Linkname, // dynamically capture clicked CTA eg: Add_manual
        authentication_method:authMethod,
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'authentication_popup', eventData);
    } catch (error) {}
  }


  authentication_error_popup(CTALink:string,LinkName:string,authMethod:string,){
    try {
      const eventData = {
        event: 'authentication_error',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        authentication_method:authMethod,
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'authentication_error', eventData);
    } catch (error) {}
  }

  

  authentication_success(CTALink:string,LinkName:string){
    try {
      const eventData = {
        event: 'authentication_success',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', 
        authentication_method:'Email'// dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, CTALink == 'Success'?'authentication_success':'authentication_error', eventData);
    } catch (error) {}
  }

  document_edit_save(CTALink:string){
    try {
      const eventData = {
        event: 'document_edit_save',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'document_edit_save', eventData);
    } catch (error) {}
  }

  document_edit_savePopup(CTALink:string){
    try {
      const eventData = {
        event: 'document_edit_save',
        screen_name:'Document Edit PopUp', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'document_edit_save', eventData);
    } catch (error) {}
  }

  document_save_success(CTALink:string){
    try {
      const eventData = {
        event: 'document_save_success',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'document_save_success', eventData);
    } catch (error) {}
  }

  document_save_successPopup(CTALink:string, Linkname:String){
    try {
      const eventData = {
        event: 'document_save_success',
        screen_name:'Document Edit PopUp', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: Linkname, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'document_save_success', eventData);
    } catch (error) {}
  }

  

  dependent_invite_success(CTALink:string,LinkName:string){
    try {
      const eventData = {
        event: 'dependent_invite_success',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'dependent_invite_success', eventData);
    } catch (error) {}
  }

  dependent_addition_success(CTALink:string){
    try {
      const eventData = {
        event: 'dependent_addition_success',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole() || 'NA', // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'dependent_addition_success', eventData);
    } catch (error) {}
  }

  dependent_addition_successAfteRes(CTALink:string, LinkName:String){
    try {
      const eventData = {
        event: 'dependent_addition_success',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole() || 'NA', // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'dependent_addition_success', eventData);
    } catch (error) {}
  }

  dependent_popup_click(CTALink:string){
    try {
      const eventData = {
        event: 'dependent_popup_click',
        screen_name: 'Dependent Edit PopUp', // Dynamically capture the page name
        event_action: `${CTALink}`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'dependent_popup_click', eventData);
    } catch (error) {}
  }

  dependent_remove(CTALink:string,LinkName:String){
    try {
      const eventData = {
        event: 'dependent_remove',
        screen_name: 'Dependent Deactivate Remove PopUp', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'dependent_remove', eventData);
    } catch (error) {}
  }

  dependent_remove_success(CTALink:string, LinkName:String){
    try {
      const eventData = {
        event: 'dependent_remove_success',
        screen_name:'Dependent Deactivate Remove PopUp', // Dynamically capture the page name
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: LinkName, // dynamically capture clicked CTA eg: Add_manual
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'dependent_remove_success', eventData);
    } catch (error) {}
  }


  mobile_update_status(CTALink:string,error:string){
    try {
      const eventData = {
        event: 'mobile_update_status',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: 'Update Status', // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        error_message:error,
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'mobile_update_status', eventData);
    } catch (error) {}
  }
  
  email_update_status(CTALink:string,error:string){
    try {
      const eventData = {
        event: 'email_update_status',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: 'Update Status', // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        error_message:error,
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'email_update_status', eventData);
    } catch (error) {}
  }


  loyalty_update_status(CTALink:string,error:string){
    try {
      const eventData = {
        event: 'loyalty_update_status',
        screen_name: this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // Dynamically capture the page name
        event_action: 'Update Status', // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture clicked CTA eg: Add_manual
        error_message:error,
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Traveler Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'loyalty_update_status', eventData);
    } catch (error) {}
  }



  approval_management(CTALink: string, result: number) {
    try {
      const eventData = {
        event: 'approval_management_click',
        screen_name: 'Approval Landing', // Dynamically capture the tab name
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture CTA if applicable eg Remove
        no_of_results: result, // pass number of results, NA if not applicable

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_management_click',
        eventData
      );
    } catch (error) {}
  }

  approval_remove(CTALink: string) {
    try {
      const eventData = {
        event: 'approval_remove',
        screen_name: 'Approval Remove PopUp', // static
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        event_action: `${CTALink == 'Proceed' ? 'Confirm' : 'Cancel'} Click`, // Dynamically capture the CTA
        link_name: CTALink, // dynamically capture CTA if applicable eg Cancel

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(this.cookiesService.analytics, 'approval_remove', eventData);
    } catch (error) {}
  }

  approval_remove_success(CTALink: string) {
    try {
      const eventData = {
        event: 'approval_remove_success',
        screen_name: 'Approval Removal popUp', // static
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        event_action: `${CTALink} Click`, // Dynamically capture the CTA
        link_name: 'Success', // static

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_remove_success',
        eventData
      );
    } catch (error) {}
  }

  approval_workflow(eventCategory: string, action: string) {
    try {
      const eventData = {
        event: 'approval_workflow_click',
        screen_name: 'Workflow Settings', // Dynamically capture the tab name
        previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        event_action: `${action} Click`, // Dynamically capture the CTA
        link_name: 'Cancel', // static

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_workflow_click',
        eventData
      );
    } catch (error) {}
  }

  workflow_next(data: any) {
    try {
      const form = data.formData.form;
      const list = data.formData.lists;
      const product = list.products.find(
        (item: { productCode: any }) => item.productCode == form.productType
      );
      const travelCat = list.travellerCategories.find(
        (item: { travelCategoryId: any }) =>
          item.travelCategoryId == form.travelCategory
      );
      const appliedON = list.appliedOn.find(
        (item: { id: number }) => item.id == form.workFlowAppliedOn
      );

      //Convert appliedForIDs in Number
      const ids = form.appliedForID
        .split(',')
        .map((id: string) => Number(id.trim()));
      const appliedForList = list.appliedFor.filter((item: { id: number }) =>
        ids.includes(item.id)
      );
      const associatesName = appliedForList.map((x: any) => x.name).join(',');

      const eventData = {
        event: 'approval_workflow_save',
        screen_name: 'Workflow Settings', // Dynamically capture the tab name
        event_action: 'Click', // Dynamically capture the CTA
        link_name: `Product: ${product.productName || ''} | Travel Category: ${
          travelCat.travelCategory || ''
        } | Workflow applied on: ${appliedON.name || ''} | Associate with: ${
          associatesName || ''
        }`, // dynamically capture the filled details

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_workflow_save',
        eventData
      );
    } catch (error) {}
  }

  approval_flow_cancel(ctaLink: string) {
    try {
      const eventData = {
        event: 'approval_flow_click',
        screen_name: 'Approval flow settings', // Dynamically capture the page name
        event_action: `${ctaLink} Click`, // Dynamically capture the CTA
        link_name: 'Cancel', // static
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_flow_click',
        eventData
      );
    } catch (error) {}
  }

  getApproverName(id: number, travelerList: any[]) {
    const user = travelerList.find((t) => t.saUserId === id);

    if (!user || !user.userName) return 'NA';

    // Remove titles (case-insensitive)
    return user.userName
      .replace(/^(mr|mrs|ms|miss|dr|prof|sir|madam)\s+/i, '')
      .trim();
  }

  approval_save(ctaLink: string, formdata: any, travelerList: any[]) {
    try {
      const inPolicyNames = {
        level1: this.getApproverName(
          formdata.inPolicyApproverIDL1,
          travelerList
        ),
        level2: this.getApproverName(
          formdata.inPolicyApproverIDL2,
          travelerList
        ),
        level3: this.getApproverName(
          formdata.inPolicyApproverIDL3,
          travelerList
        ),
      };

      const outPolicyNames = {
        level1: this.getApproverName(
          formdata.outPolicyApproverIDL1,
          travelerList
        ),
        level2: this.getApproverName(
          formdata.outPolicyApproverIDL2,
          travelerList
        ),
        level3: this.getApproverName(
          formdata.outPolicyApproverIDL3,
          travelerList
        ),
      };

      const eventData = {
        event: 'approval_flow_save',
        screen_name: 'Approval flow settings', // Dynamically capture the tab name
        event_action: `${ctaLink} Click`, // Dynamically capture the CTA
        link_name: `Approval Management Workflow: ${
          formdata.approvalFlow === 'SEQ' ? 'Sequential' : 'Parallel'
        } | Total Approvers: ${
          formdata.totalApprovals || ''
        } | In Policy Approvers: Level 1 - ${inPolicyNames.level1}, Level 2 - ${
          inPolicyNames.level2
        }, Level 3 - ${
          inPolicyNames.level3
        } | Out of Policy Approvers: Level 1 - ${
          outPolicyNames.level1
        }, Level 2 - ${outPolicyNames.level2}, Level 3 - ${
          outPolicyNames.level3
        }`, // dynamically capture filled details

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };

      this.setGTM(
        this.cookiesService.analytics,
        'approval_flow_save',
        eventData
      );
    } catch (error) {}
  }

  approval_management_filter(ctaLink: string) {
    try {
      const eventData = {
        event: 'approval_management_click',
        screen_name: 'Approval Landing', // Dynamically capture the tab name
        event_action: `${ctaLink} Click`, // Dynamically capture the CTA
        link_name: 'filter', // static

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_management_click',
        eventData
      );
    } catch (error) {}
  }

  approval_management_sort(ctaLink: string) {
    try {
      const eventData = {
        event: 'approval_management_click',
        screen_name: 'Approval Landing', // Dynamically capture the tab name
        event_action: `${ctaLink} Click`, // Dynamically capture the CTA
        link_name: 'sort', // static

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_management_click',
        eventData
      );
    } catch (error) {}
  }

  approval_management_filterApply(selectedID: any, filterList: any) {
    const result = filterList.filter((item: { id: any }) =>
      selectedID.includes(item.id)
    );
    const actionname = result.map((item: { name: any }) => item.name).join('|');
    // const result = list.filter(item => selectedIds.includes(item.id));

    try {
      const eventData = {
        event: 'approval_management_click',
        screen_name: 'Approval Landing', // Dynamically capture the tab name
        event_action: actionname, // Dynamically capture the filter applied
        link_name: 'Apply', //static

        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_management_click',
        eventData
      );
    } catch (error) {}
  }

  approval_management_afterClickSort(actionName: string, linkName: string) {
    try {
      const eventData = {
        event: 'approval_management_click',
        screen_name: 'Approval Landing', // Dynamically capture the tab name
        event_action: `${actionName} Click`, // Dynamically capture the CTA
        link_name: `${linkName}_Sort`, // dynamically capture the sort option, eg: Oldest_Sort
        member: this.getUserRole(), // dynamically capture ex: employee
        action: this._CommonService.actionName, // dynamically capture the feature name
        subaction: 'Approval Management Workflow', // dynamically capture the POD name
      };
      this.setGTM(
        this.cookiesService.analytics,
        'approval_management_click',
        eventData
      );
    } catch (error) {}
  }

  approvalSaveConfiguration(actionName: string, LinkName: string) {
    let eventData = {
      event: 'approval_save_success',
      screen_name: LinkName, // Dynamically capture the page name
      previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
      event_action: `${actionName} Click`, // Dynamically capture the CTA
      link_name: 'Success', // static
      member: this.getUserRole(), // dynamically capture ex: employee
      action: this._CommonService.actionName, // dynamically capture the feature name
      subaction: 'Approval Management Workflow', // dynamically capture the POD name
    };
    this.setGTM(
      this.cookiesService.analytics,
      'approval_save_success',
      eventData
    );
  }
  errorMessage(message: string, code: any, linkName: string) {
    let eventData = {
      event: 'view_error_message',
      event_action: 'Error messages', // static
      'screen_name ': linkName, // dynamically capture the current page name/title
      previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
      link_name: message,
      error_message: message, // dynamic
      error_code: code,
      member: this.getUserRole(), // dynamically capture ex: employee, Travel arranger
      action: this._CommonService.actionName, // dynamically capture the feature name
      subaction: 'Booking', // dynamically  capture the POD name
    };
    this.setGTM(
      this.cookiesService.analytics,
      'approval_save_success',
      eventData
    );
  }
}
